import { render, staticRenderFns } from "./GaleryPhoto.vue?vue&type=template&id=3df56a4c&scoped=true"
import script from "./GaleryPhoto.vue?vue&type=script&lang=js"
export * from "./GaleryPhoto.vue?vue&type=script&lang=js"
import style0 from "./GaleryPhoto.vue?vue&type=style&index=0&id=3df56a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df56a4c",
  null
  
)

export default component.exports